import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { PessoalService } from '../../../../providers/pessoal-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';

@Component({
    selector: 'page-nomeacao-versus-srp',
    templateUrl: 'nomeacao-versus-srp.html',
    providers: [
        PessoalService
    ]
})
export class PessoalNomeacaoVersusSRPPage extends ModulosController {
    listaDados: any = [];
    loading: boolean = true;

    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "104";
    codigoModulo: any;
    analise: any;

    page1: any = 1;

    order1: string = 'quadro.dtNomeacao';
    reverse1: boolean = true;

    filter: any = { vinculo: '', cargo: '', nome: '', cpf: '' };

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public pessoalService: PessoalService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(11);

        this.codigoModulo = this.navParams.get('analise').idModuloPca;
        this.analise = this.navParams.get('analise');

        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    carregarDados() {
        this.pessoalService.obterNomeacaoVersusSRP().subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaPessoal() {
        this.menuService.redirecionarPagina(this.pessoalService.obterIdPaginaPessoal());
    }

    salvarFlagIncluir() {
        this.loading = true;

        this.listaDados.dsResumoAnalise = this.capitalize(this.listaDados.dsResumoAnalise);
        this.pessoalService.salvarNomeacaoVersusSRP(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.loading = false;
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    submeterNoCertificado() {
        let idAnalise = "";
        this.loading = true;

        if (this.listaDados.dsResumoAnalise == undefined || !this.listaDados.dsResumoAnalise || this.listaDados.dsResumoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.dsResumoAnalise == null) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                idAnalise = this.listaDados.idModuloAnalise;

                this.pessoalService.finalizarNomeacaoVersusSRP(this.listaDados).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaPessoal();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    capitalize(str) {
        let retorno = "";

        if (str) {
            retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }

        return retorno;
    }

    cpf_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/pessoal/nomeacao-versus-srp/nomeacao-versus-srp.ts